import { MetaPages } from '../../enums/pages';
import { ContentType } from '../../types/content';
import HeaderContainer from '../../components/molecules/header-container/header-container';
import Tabs from '../../components/molecules/tabs/tabs';
import { pageRoute, supportAndServiceRoutes } from '../../config/routes/pages';
import { getSupportAndServiceHeader } from '../../services/support-and-service';
import TabTitle from '../../components/atoms/tab-title/tab-title';
import SectionContainer from '../../components/atoms/section-container/section-container';
import CustomerServiceCard from '../../components/molecules/customer-service-card/customer-service-card';
import { linkRoutes } from '../../config/routes/links';

type CustomerServiceProps = {
  supportAndServiceHeader: ContentType;
};

export function Index(props: CustomerServiceProps) {
  const { supportAndServiceHeader } = props;

  return (
    <>
      <TabTitle page={MetaPages.CUSTOMER_SERVICE} />
      <div>
        <HeaderContainer {...supportAndServiceHeader} />
        <Tabs tabItems={supportAndServiceRoutes} />
        <SectionContainer className="text-center space-y-8 md:space-y-12">
          <p className="text-header6 md:text-2header4 uppercase font-ChronicleDisplayRegular px-5">
            Customer Service
          </p>
          <div className="space-y-2 text-subtitle md:text-body">
            <p>
              Experience exceptional customer service with Focus Global
              Inc.&apos;s dedicated Customer Service Representatives and
              Technicians.
            </p>
            <p>
              With over 20 years of industry expertise, we are committed to
              providing unparalleled support and service to our valued clients.
            </p>
          </div>
          <p className="font-MuseoSans500 text-header6">
            Discover solutions with our guides.
          </p>
          <div className="flex justify-center space-x-4 md:space-x-12">
            <CustomerServiceCard
              hoverIcon="/icons/manuals-icon-hover.svg"
              icon="/icons/manuals-icon.svg"
              label="Check our Product Manuals and Guides"
              link={pageRoute.MANUALS_AND_GUIDES}
            />
            <CustomerServiceCard
              hoverIcon="/icons/use-and-care-icon-hover.svg"
              icon="/icons/use-and-care-icon.svg"
              label="Watch our Use and Care Videos"
              link={pageRoute.USE_AND_CARE_VIDEOS}
            />
          </div>

          <p className="font-MuseoSans500 text-header6">
            For further assistance, our dedicated team delivers outstanding
            support.
          </p>
          <div className="flex justify-center space-x-4 md:space-x-12">
            <CustomerServiceCard
              hoverIcon="/icons/chat-icon-hover.svg"
              icon="/icons/chat-icon.svg"
              label="Chat with a Customer Service Representative"
              link={linkRoutes.FGI_VIBER}
            />
            <CustomerServiceCard
              hoverIcon="/icons/email-icon-hover.svg"
              icon="/icons/email-icon.svg"
              label="Write Us About Your Concerns"
              link={linkRoutes.FGI_MAIL}
            />
          </div>
          <div className="h-2 border-b border-headerBackground" />
          <div className="text-subtitle md:px-24 font-MuseoSans100 md:text-body">
            You may also contact us from Monday to Friday from 7AM to 5PM and
            Saturday from 7AM to 4PM at{' '}
            <a
              className="underline hover:text-primaryBlue"
              href={linkRoutes.TEXT}
            >
              (+63917) 120 0111
            </a>{' '}
            (call/text) or{' '}
            <a
              className="underline hover:text-primaryBlue"
              href={linkRoutes.FGI_CALL}
            >
              (+632) 8634 8587
            </a>{' '}
            (landline).
          </div>
        </SectionContainer>
      </div>
    </>
  );
}

export async function getStaticProps() {
  const supportAndServiceHeader = await getSupportAndServiceHeader();

  return {
    props: {
      supportAndServiceHeader
    }
  };
}

export default Index;
